import React, { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import moment from "moment";
import ComponentToPRint from "./ComponentToPRint";

const PrintPDF = ({
  rowsData,   
  ComponentToPrint,
  HeaderToPrint,
  setOpenModal,
  pdfName,
}) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current, 
    onAfterPrint: () => {     
     
      setOpenModal(false);
    },
    documentTitle: `${pdfName}-${moment().format("MM-DD-YY-HH:mm:ss")}`,
  });
console.log(ComponentToPrint)
  useEffect(() => { 
    setOpenModal(false);

    handlePrint();
  }, []);
  return (
    <div style={{margin:"10px"}}>
      <ComponentToPRint
        ref={componentRef}
        rowsData={rowsData}
        ComponentToPrint={ComponentToPrint}
        HeaderToPrint={HeaderToPrint}
      />
      {/* <Report/> */}
      {/* <button onClick={handlePrint}>Print this out!</button> */}
    </div>
  );
};

export default PrintPDF;
